/**
 * This barrel file provides the export for the shared Advanced Search Fields list.
 */
export * from './searchfields-list.service';
